document.addEventListener("DOMContentLoaded", function () {
  const videoTitles = document.querySelectorAll(".switchable-vdo__vdo-title");
  const videoElement = document.querySelector(".switchable-vdo__vdo");

  if (!videoTitles.length || !videoElement) return;

  const video1Id = videoElement.getAttribute("data-video-1");
  const video2Id = videoElement.getAttribute("data-video-2");

  videoTitles.forEach((title) => {
    title.addEventListener("click", function () {
      const videoId = this.getAttribute("data-video-id");
      const videoWrapper = document.querySelector(
        ".switchable-vdo__vdo-wrapper lite-youtube"
      );

      // Change vdo accordinng to selected title
      if (videoId === "1") {
        videoWrapper.setAttribute("videoid", video1Id);
      } else if (videoId === "2") {
        videoWrapper.setAttribute("videoid", video2Id);
      }

      // Update active states for title
      document
        .querySelector(".switchable-vdo__line--active")
        ?.classList.remove("switchable-vdo__line--active");
      this.querySelector(".switchable-vdo__line").classList.add(
        "switchable-vdo__line--active"
      );
    });
  });
});
